angular.module('elogbooksDirectives').directive('elbHelpdeskAlarms', function ($rootScope, modulesService) {
    return {
        restrict: 'E',
        templateUrl: '/modules/directives/helpdesk-alarms/helpdesk-alarms.html',
        scope: {
            stats: '=ngModel',
            showPlannedJobs: '='
        },
        controller: ['$scope', function($scope) {
            $scope.stateName = $scope.$root.currentState;
            $scope.quotesModuleEnabled = modulesService.isEnabled('quotes');

            // The state to check to maker active
            $rootScope.$on('$stateChangeSuccess', function() {
                $scope.stateName = $scope.$root.currentState;
            });
        }]
    }
});
